import axios from 'axios';
import { isPublicPath } from './commonFunction';
import { getUrls } from '@/util/urls';

const instanceAxios = axios.create({
  baseURL: getUrls().backendUrl
});

let sensitiveAccessToken: string | null = null;

export const setSensitiveAccessToken = (token: string | null) => {
  sensitiveAccessToken = token;
};

export const getSensitiveAccessToken = () => sensitiveAccessToken;

instanceAxios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  config.headers = config.headers ?? {};
  if (token) {
    config.headers.Authorization = token;
  } else {
    sensitiveAccessToken = null;
  }
  if (sensitiveAccessToken) {
    config.headers['X-Sensitive-Access'] = sensitiveAccessToken;
  }
  return config;
});

instanceAxios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.log(error);
    if (error.response?.status === 401) {
      setSensitiveAccessToken(null);
      window.localStorage.removeItem('token');
      const pathName = window.location.pathname;
      if (!isPublicPath(pathName)) {
        window.sessionStorage.setItem('redirect', pathName);
        window.location.replace('/login');
      }
    }
    throw error;
  }
);

export default instanceAxios;
